enum InternalUserTypes {
    squadUser = 5,
    adminPlusUser = 4,
    operationUser = 3,
    solicitanteUser = 2,
}

export default InternalUserTypes;
